const CurrentColors = [
  {
    value: false,
    name: 'Teal',
    hex: '#008080',
    purpose: 'primary'
  },
  {
    value: false,
    name: 'Tundora',
    hex: '#424242',
    purpose: 'secondary'
  },
  {
    value: false,
    name: 'Light Coral',
    hex: '#FF8080',
    purpose: 'accent'
  },
  {
    value: false,
    name: 'Sunset Orange',
    hex: '#FF5252',
    purpose: 'error'
  },
  {
    value: false,
    name: 'Dodger Blue',
    hex: '#2196F3',
    purpose: 'info'
  },
  {
    value: false,
    name: 'Fruit Salad',
    hex: '#4CAF50',
    purpose: 'success'
  },
  {
    value: false,
    name: 'Amber',
    hex: '#FFC107',
    purpose: 'warnings'
  }
];

const ColorCodes = {
  data: {
    colors: [CurrentColors]
  }
}

export default ColorCodes;


// WEBPACK FOOTER //
// ./src/layouts/design/ColorCodes.js